import React from 'react';
import { EmptyStateBody, Content, ContentVariants } from '@patternfly/react-core';
import emptyStateImgUrl from '../../assets/Release.svg';
import AppEmptyState from '../../shared/components/empty-state/AppEmptyState';
import ExternalLink from '../../shared/components/links/ExternalLink';

const ReleasesEmptyState: React.FC<React.PropsWithChildren<unknown>> = () => (
  <AppEmptyState emptyStateImg={emptyStateImgUrl} title="Check out all of your releases ">
    <EmptyStateBody>
      <Content component={ContentVariants.p}>
        A release object represents a deployed snapshot of your application components. To view your
        releases, set up a release plan for your application.
      </Content>
      <ExternalLink href="https://konflux-ci.dev/docs/releasing/">
        Learn more about setting up release plans
      </ExternalLink>
    </EmptyStateBody>
  </AppEmptyState>
);

export default ReleasesEmptyState;
